export default __webpack_public_path__ + "static/350-77ad1e0ae27563f70259f3b01ae78650.jpg";